import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-screen h-screen flex items-center justify-center" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = { class: "text-2xl font-semibold text-black mb-10 select-none" }

import buddhaImage from "@/assets/buddha.webp";
import { useI18n } from "vue-i18n";
import BaseModal from "@/views/Auth/components/BaseModal.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import { computed, onMounted, ref } from "vue";
import ConfirmButton from "@/views/Auth/components/ConfirmButton.vue";
import { useRoute } from "vue-router";
import router from "@/router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { fetchChangePassword } from "@/api/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  setup(__props) {

onMounted(() => {
  const queryToken = route.query.token as string | null;
  const queryEmail = route.query.email as string | null;
  if (!queryToken || !queryEmail) {
    router.replace({ name: ROUTE_NAMES.HOME });
  } else {
    token.value = queryToken;
    email.value = queryEmail;
  }
});

const route = useRoute();
const { t } = useI18n();

const email = ref<string>("");
const token = ref<string>("");
const newPassword = ref<string>("");
const newPasswordConfirm = ref<string>("");
const waitApiCall = ref(false);

const isNewPasswordValid = computed(() => {
  const passwordsInNotEmpty =
    newPassword.value.length > 0 && newPasswordConfirm.value.length > 0;
  const passwordsAreTheSame = newPassword.value === newPasswordConfirm.value;

  return passwordsAreTheSame && passwordsInNotEmpty;
});

async function handleResetPassword() {
  try {
    waitApiCall.value = true;
    await fetchChangePassword({
      new_password: newPassword.value,
      new_password_confirmation: newPasswordConfirm.value,
      email: email.value,
      token: token.value,
    });
    await router.replace({ name: ROUTE_NAMES.USER });
  } catch (error) {
    console.log(error);
  } finally {
    waitApiCall.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseModal, {
      show: true,
      "left-image-asset": _unref(buddhaImage),
      "show-close-icon": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("auth.reset-password-title")), 1)
        ]),
        _createVNode(TextInput, {
          label: _unref(t)('auth.new-password'),
          modelValue: newPassword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event)),
          type: "password",
          class: "mb-4"
        }, null, 8, ["label", "modelValue"]),
        _createVNode(TextInput, {
          label: _unref(t)('auth.confirm-new-password'),
          modelValue: newPasswordConfirm.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPasswordConfirm).value = $event)),
          type: "password",
          class: "mb-10"
        }, null, 8, ["label", "modelValue"]),
        _createVNode(ConfirmButton, {
          disabled: !isNewPasswordValid.value || waitApiCall.value,
          loading: waitApiCall.value,
          "button-text": _unref(t)('auth.reset-password-button'),
          onClick: handleResetPassword
        }, null, 8, ["disabled", "loading", "button-text"])
      ]),
      _: 1
    }, 8, ["left-image-asset"])
  ]))
}
}

})